import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import BuyBeforeSelling from "@/pages/tools/BuyBeforeSelling";

export const Route = createFileRoute("/tools/buy-before-selling")({
  head: () => seoHead("/tools/buy-before-selling"),
  component: BuyBeforeSelling,
});
